export default __webpack_public_path__ + "static/ar_background_small-c0b9c97952d8459a06702037ef030714.webp";